<template>
  <div class="container">
    <div class="top-wrapper">
      <div class="nav-item" id="left-nav-item" @click="goSetting">
        <img src="../../../assets/image/member/icon_setting_nor.png" class="nav-icon">
      </div>
      <div class="nav-item" id="right-nav-item" @click="goNews()">
        <img src="../../../assets/image/member/icon_news_nor.png" class="nav-icon">
        <span v-if="0"></span>
      </div>
      <div class="top-info-wrapper">
        <div class="avatar-wrapper" @click="goProfileInfo">
          <img
            class="avatar"
            v-bind:src="user.member_avatar+'?'+time"
            v-if="isOnline && user && user.member_avatar"
          />
        </div>
        <p class="nickname" @click="goProfileInfo">{{ nickname }}</p>
        <div class="p level_name_wrapper" >
        	<div class='level_name'>
			<img src="../../../assets/image/member/usertopicon.png" class="img levelname-icon">{{ getlevelname }}			
			<span v-if="user.member_tema == 1">合伙人</span>
			<span v-if="user.member_tema_gj == 1">创始人</span>
			</div>
        </div>
      </div>
      <div class="info-wrapper">
        <div class="info-item" @click="goPredeposit">
          <div class="item">购物积分</div>
          <div class="item price">{{ getAvailablePredeposit }}</div>
        </div>
        <div class="info-item" @click="goRScoreList">
          <div class="item">分红积分</div>
          <div class="item price">{{ getRScore }}</div>
        </div>
		<div class="info-item" @click="goScoreList">
		  <div class="item">消费积分</div>
		  <div class="item price">{{ getScore }}</div>
		</div>
      </div>
    </div>
    <flex-line class="order-header" :is-link="true" style="padding-top:2.5rem;margin-top:0;" @click.native="goOrder">
      <span>我的订单</span>
      <span slot="right">查看全部订单</span>
    </flex-line>
    <div class="order-wrapper">
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_new"
        :src="require('../../../assets/image/member/icon_pay_nor.png')"
        title="待付款"
        :orderNumber="user.order_nopay_count"
      >
      </index-order-item>
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_pay"
        :src="require('../../../assets/image/member/icon_goods_nor.png')"
        title="待发货"
        :orderNumber="user.order_noship_count"
      >
      </index-order-item>
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_send"
        :src="require('../../../assets/image/member/icon_consignee_nor.png')"
        title="待收货"
        :orderNumber="user.order_noreceipt_count"
      >
      </index-order-item>
      <index-order-item
        class="order-item"
        testAttr="MemberOrderList"
        id="state_noeval"
        :src="require('../../../assets/image/member/icon_prices_nor.png')"
        title="待评价"
        :orderNumber="user.order_noeval_count"
      >
      </index-order-item>
    </div>

    <flex-line class="order-header">
      <span>常用工具</span>
    </flex-line>
    <div class="manage-wrapper">
      <index-manage-item
        v-on:onclick="goAccount"
        :src="require('../../../assets/image/member/icon_purse_pre.png')"
        title="我的钱包"
      >
      </index-manage-item>
      <!--<index-manage-item
        v-on:onclick="goOrder"
        :src="require('../../../assets/image/member/icon_order_pre.png')"
        title="寄售订单"
      >
      </index-manage-item>
      <index-manage-item
        v-on:onclick="goReturn"
        :src="require('../../../assets/image/member/icon_refund_pre.png')"
        title="退款管理"
      >
      </index-manage-item>
      <index-manage-item
        v-on:onclick="goFriendList"
        :src="require('../../../assets/image/member/icon_friend_pre.png')"
        title="我的好友"
      >
      </index-manage-item>

      <index-manage-item
        v-if="config && config.instant_message_open == '1' && config.instant_message_gateway_url"
        v-on:onclick="goMemberChatList"
        :src="require('../../../assets/image/member/icon_list_pre.png')"
        title="聊天列表"
      >
      </index-manage-item>
      <index-manage-item
          v-if="config && config.member_auth == '1'"
              v-on:onclick="$router.push({name:'MemberAuth'})"
              :src="require('../../../assets/image/member/icon_testimony_pre.png')"
              title="实名认证"
      >
      </index-manage-item>      
      <!--<index-manage-item
              v-on:onclick="$router.push({ name: 'MemberConsultList' })"
              :src="require('../../../assets/image/member/icon_consult_pre.png')"
              title="咨询管理"
      >
      </index-manage-item>-->
      <!-- <index-manage-item
              v-on:onclick="$router.push({ name: 'MemberInformList' })"
              :src="require('../../../assets/image/member/icon_offence_pre.png')"
              title="举报管理"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="$router.push({ name: 'MemberComplaintList' })"
              :src="require('../../../assets/image/member/icon_propose_pre.png')"
              title="投诉管理"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="goInvoice"
              :src="require('../../../assets/image/member/icon_invoice_pre.png')"
              title="发票管理"
      >
      </index-manage-item> -->
      <index-manage-item
              v-on:onclick="goAddress"
              :src="require('../../../assets/image/member/icon_address_pre.png')"
              title="收货地址"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="goEvaluateList()"
              :src="require('../../../assets/image/member/icon_judgea_pre.png')"
              title="我的评价"
      >
      </index-manage-item>      
	  <index-manage-item
	          v-on:onclick="goArrivalnotice()"
	          :src="require('../../../assets/image/member/icon_notify_pre.png')"
	          :title="getMemberID != 1 ? '到货通知' : '门店管理'"
	  >
	  </index-manage-item> 
      <index-manage-item
              v-on:onclick="goBrowse()"
              :src="require('../../../assets/image/member/icon_footprint_pre.png')"
              title="浏览记录"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="goMemberFeedback()"
              :src="require('../../../assets/image/member/icon_feedback_pre.png')"
              title="反馈意见"
      >
      </index-manage-item>
	  <index-manage-item
	          v-on:onclick="goFavourite()"
	          :src="require('../../../assets/image/member/icon_collect_pre.png')"
	          title="我的收藏"
	  >
	  </index-manage-item>
	  <index-manage-item
	          v-if="config.inviter_open === '1'"
	          v-on:onclick="goMemberInviterManage()"
	          :src="require('../../../assets/image/member/icon_popularize_pre.png')"
	          title="我的推广"
	  >
	  </index-manage-item>
    </div>

    <!--<flex-line class="order-header">
      <span>我的活动</span>
    </flex-line>
    <div class="manage-wrapper">
      <index-manage-item
              v-on:onclick="goMarketmanagelog()"
              :src="require('../../../assets/image/member/icon_exercise_pre.png')"
              title="活动记录"
      >
      </index-manage-item>
      <index-manage-item
              v-on:onclick="gBargain()"
              :src="require('../../../assets/image/member/icon_bargain_pre.png')"
              title="砍价活动"
      >
      </index-manage-item>
      <index-manage-item
              v-if="config.points_isuse === '1' && config.points_signin_isuse === '1'"
              v-on:onclick="$router.push({name:'MemberPointSignin'})"
              :src="require('../../../assets/image/member/icon_signin_pre.png')"
              title="我要签到"
      >
      </index-manage-item>
      <index-manage-item
              v-if="config.inviter_open === '1'"
              v-on:onclick="goMemberInviterManage()"
              :src="require('../../../assets/image/member/icon_popularize_pre.png')"
              title="推广管理"
      >
      </index-manage-item>
    </div>-->

    <!-- <div class="bottom-wrapper">
      <flex-line
        v-if="user.store_id"
        @click.native="goSellerInfo"
        :is-link="true"
      >
        <div>
          <img class="item-icon" src="../../../assets/image/member/icon_shop_seller_nor.png" />
          <span>店铺管理</span>
        </div>
      </flex-line>
      <div v-else>
	  <flex-line
        v-if="config && config.store_joinin_open!=0"
        @click.native="goSellerJoinin"
        :is-link="true"
      >
        <div>
          <img class="item-icon" src="../../../assets/image/member/icon_shop_seller_nor.png" />
          <span>商家入驻</span>
        </div>
      </flex-line>
      </div>

    </div> -->
    <!--<guess-like></guess-like>-->
  </div>
</template>

<script>
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
import flexLine from '../../flexLine'
import GuessLike from '../../GuessLike'
import { mapState, mapActions } from 'vuex'
import { getMemberIndex } from '../../../api/member'
import { checkInviter } from '../../../api/memberInviter'
import { Toast } from 'mint-ui'
export default {
  name: 'MemberIndex',
  data () {
    return {
      user: {},
      time: '',
      orderCount: {},
      isShow: true
    }
  },
  components: {
    flexLine,
    IndexOrderItem,
    IndexManageItem,
    GuessLike
  },
  created: function () {
    this.time = new Date().getTime()
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    if (this.isOnline) {
      getMemberIndex().then(
        response => {
          if (response && response.result.member_info) {
            this.user = response.result.member_info
          }
        },
        error => {}
      )
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      config: state => state.config.config
    }),
    getMemberID () {
      let id = 0
      if (this.isOnline && this.user.member_id) {
        id = parseInt(this.user.member_id)
      }
      return id
    },
    nickname () {
      let title = '登录/注册'
      if (this.isOnline) {
        if (
          this.user &&
          typeof this.user !== 'undefined' &&
          JSON.stringify(this.user) !== '{}'
        ) {
          title = this.user.member_nickname
        }
      }
      return title
    },
    getScore () {
      let score = '0'
      if (this.isOnline && this.user.member_points) {
        score = parseFloat(this.user.member_points).toFixed(2)
      }
      return score
    },
	getRScore () {
	  let score = '0'
	  if (this.isOnline && this.user.member_exppoints) {
	    score = parseFloat(this.user.member_exppoints).toFixed(2)
	  }
	  return score
	},
    // 预存款可用金额 通过store 进行获取
    getAvailablePredeposit () {
      let availablePredeposit = '0.00'
      if (this.isOnline && this.user.available_predeposit) {
        availablePredeposit = parseFloat(this.user.available_predeposit).toFixed(2)
      }
      return availablePredeposit
    },
    getlevelname () {
      let levelname  = ''
      if (this.isOnline && this.user.level_name) {
        levelname = this.user.level_name
      }
      return levelname
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    showLogin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goRScoreList () {	
      if (this.isOnline) {
        this.$router.push({ name: 'MemberExppointsList', query: { type: 0 } })
      } else {
        this.showLogin()
      }
    },
	goScoreList () {
	  if (this.isOnline) {
	    this.$router.push({ name: 'MemberPointList' })
	  } else {
	    this.showLogin()
	  }
	},
    goOrder () {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goProfileInfo () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberProfileSet' })
      } else {
        this.showLogin()
      }
    },
    goSetting () {
      this.$router.push({ name: 'MemberSetting' })
    },
    // 消息通知
    goNews () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberNoticeList' })
      } else {
        this.showLogin()
      }
    },
    // 我的关注
    goFavourite () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite' })
      } else {
        this.showLogin()
      }
    },
    // 我的地址
    goAddress () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAddressList' })
      } else {
        this.showLogin()
      }
    },
    // 我的退款
    goReturn () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberOrderreturn' })
      } else {
        this.showLogin()
      }
    },
    goAccount () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAccount' })
      } else {
        this.showLogin()
      }
    },
    goPredeposit () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPredepositList' })
      } else {
        this.showLogin()
      }
    },
    // 我的好友列表
    goFriendList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFriendList' })
      } else {
        this.showLogin()
      }
    },
    // 商家入驻
    goSellerJoinin () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerJoinin1' })
      } else {
        this.showLogin()
      }
    },
    // 聊天列表
    goMemberChatList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberChatList' })
      } else {
        this.showLogin()
      }
    },
    // 我的订单评价
    goEvaluateList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberEvaluateList' })
      } else {
        this.showLogin()
      }
    },
    // 发票管理
    goInvoice () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberInvoiceList' })
      } else {
        this.showLogin()
      }
    },
    // 跳转卖家管理中心
    goSellerInfo () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerIndex' })
      } else {
        this.showLogin()
      }
    },
    // 分销管理中心
    goMemberInviterManage () {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberInviterManage' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    // 意见反馈
    goMemberFeedback () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFeedback' })
      } else {
        this.showLogin()
      }
    },
    // 虚拟订单
    goVrOrder () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else {
        this.showLogin()
      }
    },
    // 活动记录
    goMarketmanagelog () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberMarketmanagelog' })
      } else {
        this.showLogin()
      }
    },
    // 砍价活动
    gBargain () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBargainlist' })
      } else {
        this.showLogin()
      }
    },
    // 到货通知
    goArrivalnotice () {
      if (this.isOnline) {
		if(this.getMemberID != 1)
           this.$router.push({ name: 'MemberArrivalnotice' })
		else
		   this.$router.push({ name: 'ChainIndex' })
      } else {
        this.showLogin()
      }
    },
    // 浏览历史
    goBrowse () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBrowseList' })
      } else {
        this.showLogin()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #f0f2f5;
  .top-wrapper {
    position:relative;
    height: 11rem;
    background-image: url("../../../assets/image/member/bg_wode_com.png");
	background-size: 100%;
    .top-info-wrapper {
      flex: 1;
      width: 100%;
      text-align: center;
    }
  }
  .nav-item {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top:0.5rem;
    span {
      width: 0.4rem;
      height: 0.4rem;
      background-color: #f0f2f5;
      border-radius: 50%;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }
  #left-nav-item {
    left: 0.5rem;
  }
  #right-nav-item {
    right: 0.5rem;
  }
  .nav-icon {
    width: 1.3rem;
    height: 1.3rem;
    text-align: center;
    color: #fff;
  }
  .avatar-wrapper {
    position:relative;
    width: 4.2rem;
    height: 4.2rem;
    border-radius: 50%;
    background-color: #fff;
    margin:0 auto;
    margin-top: 1rem;
    .avatar {
      width: 3.8rem;
      height: 3.8rem;
      border-radius: 50%;
      position:absolute;
      top:.2rem;
      left:.2rem;
    }
  }
  .nickname {
    width: 100%;
    margin-top: 0.75rem;
    font-size: $subFontSize;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }
  .level_name_wrapper{
    font-size: .6rem;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-left: 0;
    margin-right: 0;
    border-radius: .2rem;    
    display: inline-block;
  	padding: 0.1rem .2rem;
	span{background:#fff; border-radius: .1rem; color:#f00; margin-left:0.2rem; padding:0 0.2rem; font-weight:bold;}
  }
  .level_name{
  	display: flex;
  	align-items: center;
  }
  .levelname-icon{
  	width: 1rem;
  	height: .6rem;
  	padding-right: .2rem;
  }
  .info-wrapper {
    position: absolute;
    bottom:-2rem;
    left:1.5rem;
    right:1.5rem;
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: stretch;
    background-color: #fff;
    border-radius: .4rem;
    box-shadow: 0px 4px 4px #f7f7f7;
    z-index: 2;
  }
  .info-item {
    flex: 1;
    text-align: center;
    font-size: $h2;
    color:$formInputColor;
    position: relative;
    &:first-child::after{content:'';position: absolute;top:.5rem;bottom:.5rem;right:0;border-right: 1px dashed #eee;}
	&:nth-child(2)::after{content:'';position: absolute;top:.5rem;bottom:.5rem;right:0;border-right: 1px dashed #eee;}
    .item{padding-top:.5rem;}
    .price{color:$primaryColor;padding-bottom:.5rem;}
  }
  .order-header {
    background-color: #fff;
    padding:0 $pageSpace;
    margin-top:$modelSpace;
  }

  .item-title {
    font-size: $subFontSize;
    color: $formInputColor;
    font-weight:700;
  }

  .order-subtitle {
    font-size: $fontSize;
    color: $descTextColor;
  }
  .order-wrapper {
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #fff;
  }
  .order-item {
    flex: 1;
  }
  .bottom-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-top:$modelSpace;
    margin-bottom:$modelSpace;
    background: #fff;
    padding:0 $pageSpace;
    .item-icon{
      width:1.2rem;
      height:1.2rem;
      margin-right: .4rem;
    }
  }
  .manage-wrapper {
    background: #fff;
  }
}
</style>